// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__9QcZO","modal":"Modal_modal__Bt+WA","slide-down":"Modal_slide-down__YxDYs"};